export default __webpack_public_path__ + "static/media/gnosis-safe.7c18920c.svg";